/**
 * Besuchszählung – was die Zählung über eine Adresse erfahren darf.
 *
 * ════════════════════════════════════════════════════════════════════════════
 * Warum das eine eigene Datei ist
 * ════════════════════════════════════════════════════════════════════════════
 *
 * Die Zählung selbst steht in `main.tsx`, in zwei Zeilen. Diese Funktion
 * steht hier, weil sie geprüft werden muss: Sie ist der Riegel, der
 * verhindert, dass ein Passwort-Rücksetzlink in einer fremden Auswertung
 * landet. Ein Riegel ohne Test ist eine Absicht.
 *
 * ════════════════════════════════════════════════════════════════════════════
 * Was auf dem Spiel steht
 * ════════════════════════════════════════════════════════════════════════════
 *
 * Zu jedem Seitenaufruf wird die Adresse mitgeschickt. In Raporto tragen
 * mehrere Adressen hinter dem Fragezeichen ein Geheimnis:
 *
 *   /passwort-neu?token=…                 der Rücksetzlink aus der E-Mail
 *   /einladung?token=…                    die Einladung eines Mitarbeiters
 *   /anmelden?token=…                     der Anmeldelink
 *   /willkommen?sitzung=…&schluessel=…    die Rückkehr aus der Kasse
 *   /app?abo=erfolg&sitzung=…             dasselbe für ein bestehendes Konto
 *
 * `services/mail.ts` hält für diesen Fall den Satz bereit, der auch hier
 * gilt: ein Rücksetzlink in einem Protokoll ist ein Zugang in einem
 * Protokoll. Dass der Anbieter Abfrageparameter «gefiltert» ablegt, ist keine
 * Zusicherung für unsere Namen.
 *
 * ════════════════════════════════════════════════════════════════════════════
 * Warum alles und nicht eine Sperrliste
 * ════════════════════════════════════════════════════════════════════════════
 *
 * Eine Liste der verbotenen Namen – `token`, `sitzung`, `schluessel` – müsste
 * bei jedem neuen Parameter gepflegt werden. Vergessen wird sie genau einmal,
 * und der Preis ist ein Geheimnis in fremder Hand. Die ganze Abfrage fällt
 * weg; verloren geht damit `?paket=pro` auf der Bestellseite. Die Zahl der
 * Seitenaufrufe bleibt vollständig.
 *
 * Der Teil hinter `#` fällt mit, aus demselben Grund und ohne Verlust:
 * Raporto benutzt keine Ankerzustände.
 */
export function ohneAbfrage<E extends { url: string }>(ereignis: E): E {
  const schnitt = ereignis.url.search(/[?#]/)
  return schnitt < 0 ? ereignis : { ...ereignis, url: ereignis.url.slice(0, schnitt) }
}
